import api from "../PODPortal/baseApi.js"

export default{

  GetAdditionalDocument(shipmentCode) {
    return api.get("Hyperstorage/PODMetaData/GetAdditionalDocuments/" + shipmentCode);
  },

  GetPODZip(pods) {
    return api.post("Hyperstorage/Files/Download", pods, { responseType: 'arraybuffer' });
  },

  GetImage(guid) {
    return api.get("Hyperstorage/Files/GetImage/" + guid, { responseType: 'arraybuffer' });
  },

  GetPODPdfZip(filter) {
    return api.post("Hyperstorage/Files/DownloadPdf", filter, { responseType: 'arraybuffer' });
  },

  GetAllWithDachser(arg) {
    return api.post("Hyperstorage/PODMetaData/GetAllWithDachser", arg);
  },

}
